import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static get targets() {
    return ["input", "address", "city", "country", "postalCode"];
  }

  connect() {
    this._initWhenGoogleIsReady();
  }

  _initWhenGoogleIsReady() {
    if (window.google && google.maps && google.maps.places) {
      this._initAutocomplete();
    } else {
      const interval = setInterval(() => {
        if (window.google && google.maps && google.maps.places) {
          clearInterval(interval);
          this._initAutocomplete();
        }
      }, 50);
    }
  }

  _initAutocomplete() {
    this.autocomplete = new google.maps.places.Autocomplete(this.inputTarget, {
      types: ["address"],
      fields: ["address_components", "geometry"],
    });

    this.autocomplete.addListener("place_changed", this.placeChanged.bind(this));
  }

  placeChanged() {
    const place = this.autocomplete.getPlace();
    if (!place || !place.address_components) return;

    const parts = {};
    place.address_components.forEach((c) => {
      c.types.forEach((t) => {
        parts[t] = { long: c.long_name, short: c.short_name };
      });
    });

    const streetNumber = parts.street_number?.long || "";
    const route = parts.route?.long || "";
    const city =
      parts.locality?.long ||
      parts.postal_town?.long ||
      "";
    const postalCode = parts.postal_code?.long || "";
    const countryCode = parts.country?.short || "";

    this.addressTarget.value = [streetNumber, route].filter(Boolean).join(" ");
    this.cityTarget.value = city;
    this.postalCodeTarget.value = postalCode;
    this.countryTarget.value = countryCode;

    ["addressTarget", "cityTarget", "postalCodeTarget", "countryTarget"].forEach((k) => {
      const el = this[k];
      if (!el) return;
      el.dispatchEvent(new Event("input", { bubbles: true }));
      el.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }
}
